import { FormikHelpers } from "formik";
import DataLineBillingForm from "./DataLineBillingForm";
import { useCreateDataLineBilling } from "./api/createDataLineBilling";



const CreateDataLineBilling = ({handleCloseModal, dataLineID}: CreateDataLineBillingProps)  => {
  const CreateDataLineBillingMutation = useCreateDataLineBilling({data: {}, dataLineID});

  const initialValues: ICreateDataLineBillingForm = {
    billMonth: "",
    billYear: "",
    cost: "",
    lEnd: "",
    comLineID: "",
    dbDate: null,
    dbDateFrom: null,
    dbDateTo: null
  };

  const handleSubmit = async (values: ICreateDataLineBillingForm, { setSubmitting }: FormikHelpers<ICreateDataLineBillingForm>): Promise<void> => {
    try {
      await CreateDataLineBillingMutation.mutateAsync({
        data: values,
        dataLineID:dataLineID
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <DataLineBillingForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateDataLineBillingProps {
  handleCloseModal: () => void;
  dataLineID: number;
}

export default CreateDataLineBilling;